import { render, staticRenderFns } from "./ProcedureDomainMoveInAccount.vue?vue&type=template&id=69d99a73&"
import script from "./ProcedureDomainMoveInAccount.vue?vue&type=script&lang=ts&"
export * from "./ProcedureDomainMoveInAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports